import { IntlKey } from 'locales';
import { ValidationResult } from 'utils/import/validators/validator.model';

export function validateNbDecimals(value: number, expectedNbDecimals = 4): ValidationResult {
  if (countDecimals(value) > expectedNbDecimals) {
    return { isValid: false, errorMsgs: ['importFileValidator.tooManyDecimals' as IntlKey] };
  }
  return { isValid: true, value };
}

function countDecimals(value: number): number {
  if (Number.isInteger(value)) {
    return 0;
  }
  const strValue: string = value.toString();
  const decimalIndex: number = strValue.indexOf('.');
  if (decimalIndex === -1) {
    return 0;
  }
  return strValue.length - (decimalIndex + 1);
}
